import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import classes from "./yarn-preview-grid.module.css";

export const YarnShowMore = ({ children, className, ...props }: ComponentProps<"button">) => {
	return (
		<div className={classes.showMoreWrapper}>
			<button className={clsx(classes.yarnShowMore, className)} {...props}>
				{children}
			</button>
		</div>
	);
};
